var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var PaginationQueryCommand = /** @class */ (function () {
    function PaginationQueryCommand() {
        this.page = 1;
        this.limit = 16;
    }
    return PaginationQueryCommand;
}());
export { PaginationQueryCommand };
var EventQueryCommand = /** @class */ (function (_super) {
    __extends(EventQueryCommand, _super);
    function EventQueryCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return EventQueryCommand;
}(PaginationQueryCommand));
export { EventQueryCommand };
var HubBlockQueryCommand = /** @class */ (function () {
    function HubBlockQueryCommand() {
        this.queryParams = {
            page: 1,
            limit: 16,
        };
    }
    return HubBlockQueryCommand;
}());
export { HubBlockQueryCommand };
var HubCalendarQueryCommand = /** @class */ (function () {
    function HubCalendarQueryCommand() {
        this.queryParams = {
            category: 'All',
            page: 1,
            limit: 16,
            isApproved: false,
        };
    }
    return HubCalendarQueryCommand;
}());
export { HubCalendarQueryCommand };
var VisitorCalendarQueryCommand = /** @class */ (function (_super) {
    __extends(VisitorCalendarQueryCommand, _super);
    function VisitorCalendarQueryCommand() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.category = 'All';
        _this.source = 'google';
        _this.isForMapView = undefined;
        return _this;
    }
    return VisitorCalendarQueryCommand;
}(EventQueryCommand));
export { VisitorCalendarQueryCommand };
var HubCalendarActionCommand = /** @class */ (function () {
    function HubCalendarActionCommand() {
        // public queryCommand = new HubCalendarQueryCommand();
        this.queryParams = {
            category: 'All',
            categoryList: [],
            // categoryName: '', // for custom default place categories
            page: 1,
            limit: 16,
            isApproved: true,
            from: null,
            to: null,
            feedId: null,
            search: null,
            noFilter: false,
            isManuallyCreated: false,
            isHubCreated: null,
            isFacebookEvent: null,
            source: 'facebook',
            dmo: null,
            useFuzzyQuery: false,
            searchFields: "name",
        };
        this.isEventCalendar = true;
    }
    return HubCalendarActionCommand;
}());
export { HubCalendarActionCommand };
var VisitorCalendarActionCommand = /** @class */ (function () {
    function VisitorCalendarActionCommand() {
        this.queryCommand = new VisitorCalendarQueryCommand();
        this.isEventCalendar = true;
        this.isMapView = false;
    }
    return VisitorCalendarActionCommand;
}());
export { VisitorCalendarActionCommand };
var VisitorStyleCommand = /** @class */ (function () {
    function VisitorStyleCommand() {
        this.menuStyle = {
            isSideBar: false,
            menuBarMode: 'normal',
        };
    }
    return VisitorStyleCommand;
}());
export { VisitorStyleCommand };
var VisitorTripCommand = /** @class */ (function () {
    function VisitorTripCommand(item) {
        this.item = item;
    }
    return VisitorTripCommand;
}());
export { VisitorTripCommand };
var VisitorTripIdCommand = /** @class */ (function () {
    function VisitorTripIdCommand(id) {
        this.tripId = id;
    }
    return VisitorTripIdCommand;
}());
export { VisitorTripIdCommand };
var VisitorSettingsCommand = /** @class */ (function () {
    function VisitorSettingsCommand() {
    }
    return VisitorSettingsCommand;
}());
export { VisitorSettingsCommand };
var CustomEvent = /** @class */ (function () {
    function CustomEvent() {
    }
    return CustomEvent;
}());
export { CustomEvent };
var CustomDefaultPlaceCategory = /** @class */ (function () {
    function CustomDefaultPlaceCategory() {
    }
    return CustomDefaultPlaceCategory;
}());
export { CustomDefaultPlaceCategory };
var CategoryChangeData = /** @class */ (function () {
    function CategoryChangeData() {
    }
    return CategoryChangeData;
}());
export { CategoryChangeData };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/commands/pagination.query.command.ts.pre-build-optimizer.js